import React, {useCallback, useContext, useMemo, useState} from 'react'
import Dashboard from './Dashboard';
import {useQuery} from '@tanstack/react-query';
import {
    getBarChartData,
    getStudentBatteriesProfilesFetch,
    getDashboardFetch
} from 'store/middlewares/assessment.crud';
import {alerts, features, queryClient as qc} from 'keys'
import {useAlert} from 'components/Alerts/hooks';
import {roleNames} from 'keys/roles';
import {AbilityContext} from 'components/Permissions/Can';
import {permissions} from 'config/ability';
import {getCurrentSemesterAndYear} from 'utils/general';

const DashboardPage = () => {
    const {setAlerts} = useAlert()

    const [assessmentFilters, setAssessmentFilters] = useState({
        semester_and_year: getCurrentSemesterAndYear()
    })
    const [barFilters, setBarFilters] = useState({})
    const [currentDoughnutChart, setCurrentDoughnutChart] = useState(0)
    const ability = useContext(AbilityContext)
    const isSchoolSetupRole = ability.can("manage", roleNames.school_setup)
    const isStudentRole = ability.can("manage", roleNames.student)

    // const categories = queryClient.getQueryData([qc.categories])

    const {data: dashboardData = {}} = useQuery({
        queryKey: [qc.dashboard],
        queryFn: async ({signal}) => {
            const {data} = await getDashboardFetch({signal})

            // אנו מציגים פופאפ המזמין ליצור תלמיד למשתמש שאין לו תלמידים משוייכים
            // :יוצאי דופן עבורם לא נפתח את הפופאפ
            // משתמש איש קשר אדמין שאנו מציגים לו פופאפ אחר יותר כללי
            // וכן משתמש תלמיד
            if (!data.total_test_takers_count && !isSchoolSetupRole && !isStudentRole)
                openTestTakerPopup()
            return data
        }
    })

    const correctWordsPerMinuteDoughnut = useQuery({
        queryKey: [qc.correctWordsPerMinuteDoughnut, assessmentFilters.semester_and_year],
        queryFn: async () => {
            const {data} = await getStudentBatteriesProfilesFetch({assessmentFilters, headerFilters: null, testTaker: null})
            return data
        },
        // get_profiles דורש הרשאת read__battery בשרת - לא קוראים בלעדיה
        enabled: ability.can(permissions.read, features.battery)
    })

    const correctWordsPerMinuteBarChart = useQuery({
        queryKey: [qc.correctWordsPerMinuteBar, barFilters.category],
        queryFn: async () => {
            const {data} = await getBarChartData({testType: "words_correct_per_minute", assessmentFilters: barFilters})
            const nData = {}
            Object.keys(data).forEach(key => {
                if (!nData[key])
                    nData[key] = []

                nData[key].push(data[key]["2"], data[key]["3"], data[key]["4"])
            })
            console.log("nData", nData)
            return nData
        },

        // כרגע מושבת ולא עובד
        enabled: false
    })

    const openTestTakerPopup = useCallback(() => {
        setAlerts(alerts.createTestTaker, true)
    }, [])


    const commonState = {
        dashboardData,
        correctWordsPerMinuteDoughnut,
        assessmentFilters, setAssessmentFilters,
        currentDoughnutChart, setCurrentDoughnutChart,
        correctWordsPerMinuteBarChart,
        barFilters, setBarFilters
    }

    return (
        <DashboardContext.Provider value={commonState}>
            <Dashboard/>
        </DashboardContext.Provider>
    )
}

export const DashboardContext = React.createContext()
export default DashboardPage